import { Injectable } from '@angular/core'
import { MbCountriesNoAccountAdapter } from './mb-countries-no-account.adapter'

@Injectable({
  providedIn: 'root',
})
export class MbCountriesNoAccountConnector {

  constructor (protected adapter: MbCountriesNoAccountAdapter) {
  }

  load () {
    return this.adapter.load()
  }
}
